/* eslint-disable no-restricted-imports */
import { createSharedComposable, useColorMode as useVueUseColorMode } from '@vueuse/core';
/* eslint-enable no-restricted-imports */

/**
 * Shared color mode composable for the entire application.
 * Uses createSharedComposable to ensure a single instance across all components.
 * This prevents multiple instances from conflicting with each other.
 *
 * @example
 * import { useColorMode } from '@/composables/useSharedColorMode';
 *
 * const colorMode = useColorMode();
 * colorMode.value = 'dark'; // Changes theme globally
 */
export const useColorMode = createSharedComposable(() =>
  useVueUseColorMode({ initialValue: 'light' }),
);
